@if (!editMode) {
  <div class="tw:px-[15px]">

    <!-- Header: date + status pill + open link -->
    <div class="tw:flex tw:flex-wrap tw:items-center tw:gap-3 tw:mb-4">
      <span class="tw:text-xs tw:text-[#888]">{{ timelineSection.reportDate | date:'dd/MM/yyyy' }}</span>
      @if (statusLabel()) {
        <span class="badge badge-pill pr-status" [ngClass]="statusClass()">{{ statusLabel() }}</span>
      }
      <a class="tw:ml-auto tw:text-xs tw:font-semibold tw:text-[#4b3db5] tw:cursor-pointer" (click)="openReport()">View report</a>
    </div>

    <!-- Two-column: Academic | SEMH -->
    <div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-6">

      <!-- Academic -->
      <div class="tw:flex tw:flex-col tw:gap-3">
        <div class="kvp__k kvp__k--heading">Academic progress</div>

        <div class="tw:flex tw:flex-col tw:gap-1">
          <span class="tw:text-xs tw:font-semibold tw:text-[#333]">Assessment score %</span>
          <leap-v2-scale-slider [value]="timelineSection.assessmentScorePercentage ?? 0" [min]="0" [max]="100"
                                display="percent" [labels]="percentTicks" [disabled]="true">
          </leap-v2-scale-slider>
        </div>
      </div>

      <!-- SEMH -->
      <div class="tw:flex tw:flex-col tw:gap-3">
        <div class="kvp__k kvp__k--heading">SEMH update</div>

        <div class="tw:flex tw:flex-col tw:gap-1">
          <span class="tw:text-xs tw:font-semibold tw:text-[#333]">Confidence</span>
          <leap-v2-scale-slider [value]="timelineSection.confidenceRating ?? semhMin" [min]="semhMin" [max]="semhMax" [labels]="semhLabels" [colourRamp]="true" [disabled]="true"></leap-v2-scale-slider>
        </div>
        <div class="tw:flex tw:flex-col tw:gap-1">
          <span class="tw:text-xs tw:font-semibold tw:text-[#333]">Resilience</span>
          <leap-v2-scale-slider [value]="timelineSection.resilienceRating ?? semhMin" [min]="semhMin" [max]="semhMax" [labels]="semhLabels" [colourRamp]="true" [disabled]="true"></leap-v2-scale-slider>
        </div>
        <div class="tw:flex tw:flex-col tw:gap-1">
          <span class="tw:text-xs tw:font-semibold tw:text-[#333]">Independence</span>
          <leap-v2-scale-slider [value]="timelineSection.independenceRating ?? semhMin" [min]="semhMin" [max]="semhMax" [labels]="semhLabels" [colourRamp]="true" [disabled]="true"></leap-v2-scale-slider>
        </div>
        <div class="tw:flex tw:flex-col tw:gap-1">
          <span class="tw:text-xs tw:font-semibold tw:text-[#333]">Motivation</span>
          <leap-v2-scale-slider [value]="timelineSection.motivationRating ?? semhMin" [min]="semhMin" [max]="semhMax" [labels]="semhLabels" [colourRamp]="true" [disabled]="true"></leap-v2-scale-slider>
        </div>
        <div class="tw:flex tw:flex-col tw:gap-1">
          <span class="tw:text-xs tw:font-semibold tw:text-[#333]">Self-regulation</span>
          <leap-v2-scale-slider [value]="timelineSection.selfRegulationRating ?? semhMin" [min]="semhMin" [max]="semhMax" [labels]="semhLabels" [colourRamp]="true" [disabled]="true"></leap-v2-scale-slider>
        </div>
      </div>

    </div><!-- /two-column -->

    <!-- Summaries -->
    <div class="tw:mt-5 tw:flex tw:flex-col tw:gap-4">
      <div class="kvp kvp--stacked">
        <div class="kvp__k kvp__k--heading">Summary of last 6 weeks' progress:</div>
        <div class="kvp__v kvp__v--long-text">{{ timelineSection.last6WeeksSummary }}</div>
      </div>
      <div class="kvp kvp--stacked">
        <div class="kvp__k kvp__k--heading">Plan for the next 6 weeks:</div>
        <div class="kvp__v kvp__v--long-text">{{ timelineSection.next6WeeksPlan }}</div>
      </div>
    </div>

  </div>
}
